module.exports = __webpack_public_path__ + "img/11.862871e2.png";